import React from "react";

import ExploreOneColumnCategoryScreen from "@/screens/Explore/ExploreCategory/Components/CategoryScreen/ExploreOneColumnCategoryScreen";
import ExploreTwoColumnCategoryScreen from "@/screens/Explore/ExploreCategory/Components/CategoryScreen/ExploreTwoColumnCategoryScreen";
import ExploreNearbyCategoryScreen from "@/screens/Explore/ExploreCategory/Components/CategoryScreen/ExploreNearbyCategoryScreen";
import { AppUserSession } from "@/schemas/auth/session";
import {
  RecommendationCategory,
  RecommendationCategoryFeed,
} from "@/schemas/user/explore";

type Props = {
  session: AppUserSession;
  categoryData: RecommendationCategoryFeed;
  isDevTab?: boolean;
  isMarketingMode?: boolean;
};

function ExploreByCategoryScreen({
  session,
  categoryData,
  isDevTab = false,
  isMarketingMode = false,
}: Props): React.JSX.Element {
  switch (categoryData.category) {
    case RecommendationCategory.FRIENDS:
    case RecommendationCategory.DATING:
      return (
        <ExploreOneColumnCategoryScreen
          session={session}
          categoryData={categoryData}
          isDevTab={isDevTab}
          isMarketingMode={isMarketingMode}
        />
      );
    case RecommendationCategory.TRENDING:
    case RecommendationCategory.ONLINE_NOW:
    case RecommendationCategory.NEW_USERS:
      return (
        <ExploreTwoColumnCategoryScreen
          session={session}
          categoryData={categoryData}
          isDevTab={isDevTab}
          isMarketingMode={isMarketingMode}
        />
      );
    case RecommendationCategory.NEARBY:
      return (
        <ExploreNearbyCategoryScreen
          session={session}
          categoryData={categoryData}
          isDevTab={isDevTab}
          isMarketingMode={isMarketingMode}
        />
      );
    default:
      throw new Error(
        `ExploreByCategoryScreen: Unhandled category type: ${categoryData.category}`,
      );
  }
}

export default ExploreByCategoryScreen;
